import React from "react";
import "./HeroPaint.css";
import desktopBG from "../assets/paint-bg.png";
import mobileBG from "../assets/hpm.png";

export default function HeroPaint() {
  return (
    <section
      className="hero-paint"
      style={{
        "--hero-paint-bg-desktop": `url(${desktopBG})`,
        "--hero-paint-bg-mobile": `url(${mobileBG})`,
      }}
    >
      <div className="hero-paint-overlay"></div>
      <div className="hero-paint-content">
        <div className="text-content">
          <h1>Paint Calculator - Get the Perfect Estimate Every Time</h1>
          <p>
            Easily calculate how much paint your space needs. No guesswork, no
            wastage -- just accurate coverage for your next project.
          </p>
        </div>
        <button>Order your paint now</button>
      </div>
    </section>
  );
}
